var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = parseFloat(_vm.totalPrice)

  var m1 = require("@/static/public/angle.png")

  var l0 = _vm.__map(_vm.pricesList, function(t, i) {
    var m2 = _vm.format(t.date, "M-D")
    return {
      $orig: _vm.__get_orig(t),
      m2: m2
    }
  })

  if (!_vm._isMounted) {
    _vm.e0 = function($event) {
      _vm.isNameError = !_vm.testName()
    }

    _vm.e1 = function($event) {
      _vm.isPhoneError = !_vm.testPhone()
    }

    _vm.e2 = function($event) {
      _vm.isIDError = !_vm.testID()
    }

    _vm.e3 = function($event) {
      _vm.popupShow = !_vm.popupShow
    }

    _vm.e4 = function($event) {
      _vm.popupShow = false
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        l0: l0
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }